 export enum ShipmentSearchFields {
    ShipmentId = 'ID',
    ReferenceNumber = 'REFERENCE_NUMBER'
  }